<template>
  <div>
    <div class="BookingForm-section my-4 py-4 px-8 px-md-12" v-for="link in links" :key="link.id">
      <h2 class="mb-1">{{ link.title }}</h2>
      <p>{{ $t('manage.bookingForm.subtitles') }}</p>
      <div class="Section-container my-8">
        <div class="Section-copy pa-6" @click="copyLink(link)">
          <v-icon class="Section-icon">mdi-file-multiple</v-icon>
        </div>
        <div class="pa-6">
          <span class="Section-link">{{ link.link }}</span>
          <input type="hidden" :class="`Section-link--${link.id}`" :value="link.link" />
        </div>
      </div>
      <div v-if="showTooltip[link.id]">
        <v-alert type="sucess" color="primary" text dense>
          {{ $t('manage.bookingForm.copyMessage') }}
        </v-alert>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookingForm',
  data() {
    return {
      showTooltip: {
        booking: false,
        embed: false,
        landing: false
      },
      links: [
        // {
        //   id: 'booking',
        //   title: this.$t('manage.bookingForm.titles.website'),
        //   link: `<iframe src="${window.location.origin}/booking.html" title="Essilor Booking"></iframe>`
        // }
        {
          id: 'landing',
          title: this.$t('manage.bookingForm.titles.essilor'),
          link: `${window.location.origin}/landing.html?shopUuid=${this.$store.state.currentShopUuid}`
        },
        {
          id: 'embed',
          title: this.$t('manage.bookingForm.titles.page'),
          link: `<iframe src="${window.location.origin}/embed.html?shopUuid=${this.$store.state.currentShopUuid}" title="Essilor Embed" width="100%" height="869px" frameBorder="0"></iframe>`
        }
      ]
    }
  },
  methods: {
    copyLink(currentLink) {
      navigator.clipboard.writeText(currentLink.link)
      this.showTooltip[currentLink.id] = true
      setTimeout(() => (this.showTooltip[currentLink.id] = false), 2500)
    }
  }
}
</script>

<style scoped lang="scss">
.BookingForm-section {
  background-color: #fff;
  p {
    font-size: 1.1rem;
  }
}

.Section-container {
  display: flex;
  max-width: 1000px;
  position: relative;

  > div {
    background-color: var(--v-secondary-lighten1);
    &:first-child {
      border-right: 1px solid #fff;
      transition: 0.35s;
      cursor: pointer;
      &:hover {
        background-color: var(--v-secondary-lighten2);
      }
    }
  }
}

.Section-icon {
  border-left: 1px solid #fff;
  position: relative;
}

.Section-link {
  word-break: break-word;
}
</style>
